import { render, staticRenderFns } from "./UsersInCompany.vue?vue&type=template&id=fc837c52&"
import script from "./UsersInCompany.vue?vue&type=script&lang=js&"
export * from "./UsersInCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports